import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SystemConfigurationComponent } from './system-configuration.component';

const routes: Routes = [
  {
    path: '',
    component: SystemConfigurationComponent,
    data: { title: 'System Configuration' },
    children: [
      {
        path: 'whatsapp-alert-configuration',
        loadChildren: () =>
          import('./alert-configuration/alert-configuration.module')
            .then(m => m.AlertConfigurationModule),
        data: {
          channel: 'WHATSAPP',
          module: 'WHATSAPP CONFIGURATION',
          title: 'WhatsApp Alert Configuration'
        }
      },
      {
        path: 'email-alert-configuration',
        loadChildren: () =>
          import('./alert-configuration/alert-configuration.module')
            .then(m => m.AlertConfigurationModule),
        data: {
          channel: 'EMAIL',
          module: 'EMAIL CONFIGURATION',
          title: 'Email Alert Configuration'
        }
      }
    ]
  }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SystemConfigurationRoutingModule { }
